var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"private-feedback-collapsed-button",on:{"click":_vm.openExpandedFeedbackPanel}},[_c('span',{staticClass:"arrow-icon"},[_c('aha-icon',{attrs:{"name":"arrow-no-tail","viewBox":"0 0 8 14","width":"12","height":"21"}})],1),_c('div',{staticClass:"text capitalize"},[_vm._v("\n    "+_vm._s(_vm.$t('Get feedback'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }